import { buttonVariants, type ButtonVariant } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { ComponentProps, MouseEvent } from 'react'

export type ScrollEdgeButtonProps = ComponentProps<'button'> & {
  edge: 'top' | 'bottom'
  variant?: ButtonVariant
}

function ScrollEdgeButton({
  edge,
  className,
  onClick,
  variant = 'secondary',
  ...props
}: ScrollEdgeButtonProps) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onClick?.(event)
  }

  return (
    <button
      {...props}
      type="button"
      data-slot="scroll-edge-button"
      data-edge={edge}
      className={cn(
        buttonVariants({ variant }),
        'h-2 w-full rounded-none p-0 enabled:active:scale-100',
        edge === 'top' ? 'rounded-t-md' : 'rounded-b-md',
        className
      )}
      onClick={handleClick}
    />
  )
}

export { ScrollEdgeButton }
